import { createContext, useContext } from 'react'

interface VideoPlayerContextType {
  seekTo: (timeInSeconds: number) => void
}

const VideoPlayerContext = createContext<VideoPlayerContextType | null>(null)

export const VideoPlayerProvider = VideoPlayerContext.Provider

export function useVideoPlayer() {
  const context = useContext(VideoPlayerContext)
  return context
}
